import { render, staticRenderFns } from "./AddPaymentFromBank.vue?vue&type=template&id=5d04e3b9&"
import script from "./AddPaymentFromBank.vue?vue&type=script&lang=js&"
export * from "./AddPaymentFromBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports